<template>
  <section class="rechargeGuide">
    <ul>
      <li v-for="(item, index) in list"
          :key="index">
        <p class="introduction">{{item.introduction}}</p>
        <img :src="item.imgUrl"
             alt>
      </li>
    </ul>
  </section>
</template>

<script>
// import axios from "axios"
export default {
  name: "rule",
  data() {
    return {
      list: [
        {
          introduction:
            "1. 确保【App内购买项目】的访问限制已经打开，步骤：【设置】→【屏幕使用时间】→【内容和隐私访问限制】→【iTunes与App Store购买项目】→【APP内购买项目】",
          imgUrl: "https://cdn.gelonghui.com/webActive/payment_step1.png"
        },
        {
          introduction:
            "2. 打开App Store，选择【APP】页面并滑到底部，选择【绑定支付宝、微信支付或银联卡】",
          imgUrl: "https://cdn.gelonghui.com/webActive/payment_step2.png"
        },
        {
          introduction: "3. 如果您还没有登录Apple ID，请先登录Apple ID",
          imgUrl: "https://cdn.gelonghui.com/webActive/payment_step3.png"
        },
        {
          introduction: "4. 相关信息填写完成后，点击右上角【完成】",
          imgUrl: "https://cdn.gelonghui.com/webActive/payment_step4.png"
        },
        {
          introduction: "5. 返回【格隆汇App】内完成支付",
          imgUrl: ""
        }
      ]
    };
  },
  created() { },
  mounted() {
    document.title = "支付引导";
  }
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
}

.rechargeGuide {
  position: relative;
  padding: 40px;
  max-width: 750px;
  width: 100%;
  text-align: center;
  // background-color: #282C37;
  background: #ffffff;
  li {
    padding: 35px 0 35px;
  }
  .introduction {
    text-align: left;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 1px;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
  }
  img {
    margin-top: 20px;
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/member-share/rechargeGuide.vue